__turbopack_context__.v({
  "banner": "W7aiPq_banner",
  "text": "W7aiPq_text",
});
